import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import { svgIcons } from '../../../../style/fonts/SvgIcons'
import { Tooltip as ReactTooltip } from "react-tooltip";
import ModalComponent from '../../../../core/common/modal/ModalComponent';
import { useGetTeamMembersEmailQuery, useLazyGetTeamMembersEmailQuery, useSendEmailMutation } from '../../../../services/EndPointsApis';
import DateComp from '../../../../core/common/dateComponent/DateComp';
import TextField from '../../../../core/common/textFields/TextField';
import { useFormik } from 'formik';
import Select, { StylesConfig } from "react-select";
import { customStyles } from '../../../../core/common/Custom Style/CustomStyle';
import RichTextEditor from '../../../../core/common/Rich Text Editor/RichTextEditor';
import { toast } from 'react-toastify';
import Pagination from "../../../../core/common/pagination/Pagination";

// import DOMPurify from "dompurify";

const AllProjectNotes = ({ handleEditNotes, projectLookups, getallpNotes, strikeOut, handleStrikeOut, editNotes, projectId, setPageNumber,pageSize,setPageSize }: any) => {
    const [showModal, setShowModal] = useState(false);
    const [modalTitlePopup, setModalTitlePopup] = useState('');
    const [noteDescription, setNoteDescription] = useState('');

    //email api
    const [sendEmail, { data, isSuccess }] = useSendEmailMutation()
    //getTeam Member Email
    const [triggerTeamsMember, { data: getTeamMembers, isSuccess: isSuccessEmail }] = useLazyGetTeamMembersEmailQuery()

    const [emails, setEmails] = useState<string[]>([]);
    const [inputValue, setInputValue] = useState("");
    const [fileData, setFileData] = useState<File[]>([]);

    const isValidEmail = (email: string) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const decodeHtml = (html: any) => {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value; 
    }
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter" && inputValue.trim()) {
            e.preventDefault();
            const email = inputValue.trim();

            if (isValidEmail(email) && !formik.values.ExternalEmailAddresses.includes(email)) {
                formik.setFieldValue("ExternalEmailAddresses", [
                    ...formik.values.ExternalEmailAddresses.filter(email => email !== ""),
                    email,
                ]);
                setInputValue("");
            }
        }
    };
    const removeEmail = (email: string) => {
        const filteredEmails = formik.values.ExternalEmailAddresses.filter((e: string) => e !== email);
        formik.setFieldValue("ExternalEmailAddresses", filteredEmails);
    };
    const handleClose = () => {
        setShowModal(false);
    };

    const handleSave = () => {
        formik.handleSubmit();
    };
    const handleGetTeamMembers = () => {
        triggerTeamsMember({ projectId: projectId })
    }

    const handleEmail = (item: any) => {
        setModalTitlePopup(`${item?.lst_NoteType?.value} Email` || '')
        setShowModal(true);
        setNoteDescription(item.description || '');
        formik.setFieldValue('Body', item.description || '')

    }
    const initialValues = {
        Subject: "",
        InternalEmailAddresses: [
            {
                id: 0,
                value: ''
            }
        ],
        ExternalEmailAddresses: [
            ""
        ],
        Body: '',
        Attachments: [

        ]
    }


    const formik = useFormik({
        initialValues,
        // validationSchema: loginSchema,
        onSubmit: async (values) => {
            const formData = new FormData();
            formData.append("Subject", values.Subject);
            formData.append("InternalEmailAddresses", values.InternalEmailAddresses.map(item => item.value).toString());
            formData.append("ExternalEmailAddresses", values.ExternalEmailAddresses.toString());
            formData.append("Body", values.Body);

            fileData.forEach((file, index) => {
                formData.append("Attachments", file);
            });
            // formData.append("Attachments", fileData.toString());
            // });
            // fileData.map((file, index) => formData.append(`files[${index}]`, file));

            try {
                await sendEmail(formData).unwrap();
                toast.success("File uploaded successfully");
                formik.resetForm();
                setShowModal(false)
            } catch (error) {

            }
        },
    });

    const selectValues = formik.values?.InternalEmailAddresses
        ? formik.values.InternalEmailAddresses
            .filter((users: { id: number; value: string }) => users.id !== 0 && users.value !== '')
            .map((users: { id: number; value: string }) => ({
                value: users?.id,
                label: users?.value,
            }))
        : [];

    const handleChange = (newValue: any) => {
        const updatedValues = newValue.map((option: { value: any; label: any }) => ({
            id: option.value,
            value: option.label
        }));

        formik.setFieldValue('InternalEmailAddresses', updatedValues);

    };

    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (files && files.length > 0) {
            const fileArray = Array.from(files);
            setFileData(fileArray);
            formik.setFieldValue("Attachments", fileArray);
        }
    };

    useEffect(() => {
        if (getTeamMembers?.result && isSuccessEmail) {
            formik.setFieldValue(
                'InternalEmailAddresses',
                getTeamMembers.result.map((member: any) => {
                    return ({
                        id: member.id,
                        value: member.value,
                    })
                })
            );
        }
    }, [getTeamMembers?.result, isSuccessEmail]);


    const handlePageSizeChange = (selectedOption: any) => {
        setPageSize(selectedOption.value);
        setPageNumber(1);
      };
      const handlePageClick = (e: any) => {
        setPageNumber(e.selected + 1);
      };


    return (
        <>
            <ModalComponent
                buttonText="Send"
                modalTitle={modalTitlePopup}
                onClose={handleClose}
                onSave={handleSave}
                isVisible={showModal}
                cancelButton="Cancel"
                saveButton='Send'
            >
                <>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className="input-label">
                                <TextField
                                    label="Subject"
                                    required
                                    type="text"
                                    {...formik.getFieldProps("Subject")}
                                />
                            </div>
                            <div className='col-md-12'>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <label>Internal Users</label>
                                    <button className='btn btn-primary mb-1 mt-1 fs-11' onClick={handleGetTeamMembers}>
                                        Get Team Members
                                    </button>
                                </div>
                                <Select
                                    isMulti={true}
                                    styles={customStyles}
                                    className="select multi-select"
                                    options={projectLookups?.result?.ActiveUserEmail?.map((option: any) => ({
                                        label: option?.value,
                                        value: option?.id
                                    })) || []}
                                    value={
                                        selectValues
                                    }
                                    onChange={(newValue: any) => handleChange(newValue)}
                                />
                            </div>
                            <div className="col-md-12">
                                <div className="d-flex justify-content-between">
                                    <label className='input-label'>External Users</label>
                                </div>
                                <div className="email-input-container">
                                    <div className="badges-container">
                                        {formik.values.ExternalEmailAddresses[0] !== '' ? (
                                            formik.values.ExternalEmailAddresses.map((email: string, index: number) => (
                                                <span key={index} className="badge badge-pill badge-primary me-2">
                                                    {email}{" "}
                                                    <button
                                                        type="button"
                                                        className="btn-close ms-1"
                                                        onClick={() => removeEmail(email)}
                                                    >
                                                        &times;
                                                    </button>
                                                </span>
                                            ))
                                        ) : (
                                            <span className="text-muted">...</span>
                                        )}
                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder="Enter email and Press enter"
                                            value={inputValue}
                                            onChange={(e) => setInputValue(e.target.value)}
                                            onKeyDown={handleKeyDown}
                                        />
                                    </div>
                                    {formik.errors.ExternalEmailAddresses && (
                                        <div className="text-danger">{formik.errors.ExternalEmailAddresses}</div>
                                    )}
                                </div>
                            </div>
                            <div className='col-md-12'>
                                <RichTextEditor
                                    value={formik.values.Body}
                                    name="Message"
                                    onChange={(value: any) => formik.setFieldValue('Body', value)}
                                />
                            </div>
                            <div className='col-md-12'>
                                <div className='d-flex flex-column'>
                                    <label className='input-label'> Attachments</label>
                                    <input type="file" className=''
                                        onChange={handleFileUpload}
                                        id="file"
                                        name="file"
                                        accept=".png, .jpg, .jpeg, .pdf"
                                        multiple
                                        style={{
                                            border: '2px dashed #ccc',
                                            borderRadius: '8px',
                                            padding: '20px',
                                            textAlign: 'center',
                                            backgroundColor: '#f0f8ff',
                                            cursor: 'pointer',
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            </ModalComponent>

            <ReactTooltip
                id="my-tooltip-1"
                place="top"
                content="copy to another Project"
                style={{ color: "#B11F28", backgroundColor: '#F8E9EA' }}
            />
            <ReactTooltip
                id="my-tooltip-2"
                place="top"
                content="Strikeout"
                style={{ color: "#B11F28", backgroundColor: '#F8E9EA' }}
            />
            <ReactTooltip
                id="my-tooltip-3"
                place="top"
                content="Send email"
                style={{ color: "#B11F28", backgroundColor: '#F8E9EA' }}
            />
            <ReactTooltip
                id="my-tooltip-4"
                place="top"
                content="Private"
                style={{ color: "#B11F28", backgroundColor: '#F8E9EA' }}
            />
            <div className="task-wrapper mt-3" style={{ height: '422px', overflow: 'auto' }}>
                {
                    getallpNotes?.result?.data?.map((item: any, index: any) => (
                        <div key={item.id}>
                            <Link
                                to="#"
                                className="task-accordion"
                                data-bs-toggle="collapse"
                                data-bs-target={`#${item.id}`}
                                onClick={(e) => e.preventDefault()}
                            >
                                <div className="noti-content mt-3">
                                    <ul className="notification-list">
                                        <li className="notification-message">
                                            <Link to="#" onClick={(e) => e.preventDefault()}>
                                                <div className="d-flex gap-2 align-items-center">
                                                    <h6 className="">
                                                        <span className="mb-0 icon-style me-2">{svgIcons.NotesIcon}</span>
                                                    </h6>
                                                    <div className="task-info">
                                                        <p className={`mb-0 ${strikeOut === item.id ? 'line-through' : ''}`}>
                                                            <h6>{item.title}</h6>
                                                        </p>
                                                        {/* {item.title !== "Action Note" &&
                                                            <>
                                                                <p className={`mb-0 ${strikeOut === item.id ? 'line-through' : ''}`}>
                                                                    <h6 className="text-muted">of Type</h6>
                                                                </p>
                                                                <p className={`mb-0 ${strikeOut === item.id ? 'line-through' : ''}`}>
                                                                    <h6>{item?.lst_NoteType?.value}</h6>
                                                                </p>
                                                            </>
                                                        } */}
                                                        <p className={`mb-0 ${strikeOut === item.id ? 'line-through' : ''}`}>
                                                            <h6 className="text-muted">created by</h6>
                                                        </p>
                                                        <p className={`mb-0 ${strikeOut === item.id ? 'line-through' : ''}`}>
                                                            <h6>{item.lst_CreatedBy?.value || ''}</h6>
                                                        </p>
                                                        <p className={`mb-0 ${strikeOut === item.id ? 'line-through' : ''}`}>
                                                            <h6 className="text-muted">at</h6>
                                                        </p>
                                                        <p className={`mb-0 ${strikeOut === item.id ? 'line-through' : ''}`}>
                                                            <h6><DateComp formattedDate={item.createdDT} /></h6>
                                                        </p>
                                                        {editNotes &&
                                                            <button className="btn btn-transparent border-0" onClick={() => handleEditNotes(item.id)} disabled={item.title === "Action Note"}>
                                                                {svgIcons.updateIcon}
                                                            </button>
                                                        }
                                                        {/* <div data-tooltip-id="my-tooltip-1" className="ms-2">
                                                            {svgIcons.CopyIcon}
                                                        </div> */}
                                                        <div data-tooltip-id="my-tooltip-2" className="ms-2" onClick={() => handleStrikeOut(item.id)}>
                                                            {svgIcons.strikeIcon}
                                                        </div>
                                                        <div data-tooltip-id="my-tooltip-3" className="ms-2" onClick={() => handleEmail(item)}>
                                                            {svgIcons.email}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </Link>
                            <div className="tasks-activity tasks collapse show" key={item.id} id={item.id}>
                                <ul>
                                    <li className='px-5'>
                                        <p className={`noti-details mb-0 ${strikeOut === item.id ? 'line-through' : ''}`}
                                            style={{ whiteSpace: 'pre-wrap' }}

                                        >
                                            {item.title !== "Action Note" ?
                                                "Description :" : ""}
                                            <br />
                                            <span dangerouslySetInnerHTML={{ __html: decodeHtml(item.description) }} />
                                        </p>

                                        <p className={`noti-details mb-0 mt-2 ${strikeOut === item.id ? 'line-through' : ''}`}>
                                            Privacy Type: {item.privacyType === 0 ? 'Client' : 'Internal'}
                                        </p>
                                        <p className={`noti-details mb-0 ${strikeOut === item.id ? 'line-through' : ''}`}>
                                            Updated At: <DateComp formattedDate={item.modifiedDT} />
                                        </p>
                                    </li>
                                </ul>
                            </div>
                            <hr />
                        </div>
                    ))
                }
            </div>
            <Pagination
                onChange={handlePageSizeChange}
                pageSize={pageSize}
                onPageChange={handlePageClick}
                pageCount={getallpNotes?.result?.totalPages || 0}
            />
        </>
    )
}

export default AllProjectNotes